'use client';

import FlyoutWrapper from "@/app/features/sites/header/ui/desktop/flyout-info/FlyoutWrapper";
import ContactView from "@/app/__to_be_integrated/_____components/_NEW/contact/ContactView";
import { Box } from "@mui/material";
import { startTransition, useEffect, useState } from "react";
import { loadApproachFlyoutContent } from "@/app/features/sites/header/ui/desktop/flyout-info/flyouts/data-access/preload";
import { Contact } from "@/app/lib/generated/graphql-types";
import ErrorBox from "@/app/__to_be_integrated/_____components/_NEW/ErrorBox";
import dynamic from "next/dynamic";

const ContactMap = dynamic(() => import("@/app/__to_be_integrated/_____components/map/ContactMap"), {
    ssr: false,
});

export default function ApproachFlyoutInfo() {
    const [content, setContent] = useState<Contact>();
    const [error, setError] = useState<string | null>(null);
    const [renderMap, setRenderMap] = useState(false);

    useEffect(() => {
        let timeoutId: number | undefined;

        (async () => {
            const { data, error } = await loadApproachFlyoutContent();
            if (error || !data) {
                console.error('Error loading approach flyout content:', error);
                setError('Fehler beim Laden der Inhalte. Bitte versuchen Sie es später erneut.');
                return;
            }

            setContent(data);
            timeoutId = window.setTimeout(() => {
                startTransition(() => {
                    setRenderMap(true);
                });
            }, 240);
        })()

        return () => {
            if (timeoutId !== undefined) {
                window.clearTimeout(timeoutId);
            }
        };
    }, []);

    if (error) return <ErrorBox error={error} />
    if (content === undefined) return null;

    return (
        <FlyoutWrapper
            backgroundComponent={(
                <Box className="absolute left-0 right-0 top-0 bottom-0">
                    {renderMap && <ContactMap contact={content} consentPosition={{ vertical: "center", horizontal: "left" }} />}
                </Box>
            )}
            hideBackgroundOnMobile={false}
            fit="fit"
            contentSide="right"
        >
            <Box className="w-full content-center justify-center px-16 py-4 md:mb-0">
                <ContactView contact={content} variant="address" />
            </Box>
        </FlyoutWrapper>
    )
}
